import React from 'react'
import comingSoonImage from "assets/images/illustrations/underdevelopment.png";


export default function ComingSoon() {
    return (
        <div className="flex items-center justify-center w-full h-full min-h-[calc(100vh-100px)]">
            <div className="flex flex-col items-center justify-center">
                <img
                    src={comingSoonImage}
                    alt="Coming Soon"
                    className="max-w-full w-full sm:w-96 md:w-[500px] h-auto"
                />
            </div>
        </div>
    )
}